<div>
    <div class="d-sm-none d-md-block">
        <toolbar></toolbar>
    </div>
    <div class="usnrPage">
        <header class="d-sm-none d-md-block"></header>
        <router-outlet></router-outlet>
        <footer class="d-sm-none d-md-block"></footer>
    </div>
</div>
